
































































import { ApiResponse } from '@ustra/data/src/models/api-model'
import { HttpMethod } from '@ustra/core/src/server/http/const'
import { Component, Prop } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'

import { PagingHeader } from '@hds/help-common/src//models/paging-header-model'
import { Ven1stSearchList, Ven2ndSearchList, VenSearchCondition } from '~/model/vendor-search-model'
import HsPagination from '~/components/common/hs-pagination.vue'

@Component({
  name: 'HsVenSearchButton',
  components: { HsPagination },
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  // #region variables
  @Prop() value: VenSearchCondition

  // 1 = 1차협력사, 2 = 2차협력사
  @Prop({ default: 1 }) type?: number
  @Prop({ default: '' }) primaryVencd?: string

  @Prop({ default: false }) disabledBtn: boolean

  // init
  // 협력사 검색 팝업
  popupKey = 1
  searchVendorPop = false
  searchProgress = false
  searchType = '협력사명'
  searchInput = ''
  selectedItem: VenSearchCondition
  activeIndex = null

  // 협력사 검색 API
  pageInfo: PagingHeader = {
    currentPage: 1,
    pageSize: this.$ustra.hs.store.cmData.appProp.pageSize,
    totalRecords: 0,
  }

  venResultList: Ven1stSearchList[] | Ven2ndSearchList[] = []

  init() {
    this.pageInfo.currentPage = 1
    this.pageInfo.totalRecords = 0
    this.activeIndex = null
    this.venResultList = []
    this.searchType = '협력사명'
    this.searchInput = ''
  }

  created() {
    this.init()
    if (this.type === 1) {
      this.selectedItem = {
        venCd: this.value.venCd,
        venNm: this.value.venNm,
      }
    } else {
      this.selectedItem = {
        venCd: this.primaryVencd,
        ven2Cd: this.value.ven2Cd,
        ven2Nm: this.value.ven2Nm,
      }
    }
  }

  onClickVenItem(index) {
    this.selectedItem = { ...this.venResultList[index] }
    this.activeIndex = index
  }

  onClickSearchOpen() {
    this.init()
    this.popupKey += 1
    this.searchVendorPop = true
    if (this.type === 1) {
      this.selectedItem = {
        venCd: this.value.venCd,
        venNm: this.value.venNm,
      }
    } else {
      this.selectedItem = {
        venCd: this.primaryVencd,
        ven2Cd: this.value.ven2Cd,
        ven2Nm: this.value.ven2Nm,
      }
      console.log(this.selectedItem)
    }
  }

  onClickConfirm() {
    if (this.selectedItem.venCd === null) return alert('협력사를 선택해 주세요')
    this.$emit('input', this.selectedItem)
    this.searchVendorPop = false
  }

  onClickSearchVen() {
    this.activeIndex = null
    this.callVenList()
  }

  onClickPageSearchVen(pageNum: number) {
    this.activeIndex = null
    this.callVenList(pageNum)
  }

  async callVenList(currentPage: number = 1) {
    this.searchProgress = true
    this.venResultList = null
    const header: PagingHeader = {
      ...this.pageInfo,
      currentPage,
    }

    try {
      let result
      if (this.type === 1) {
        const body: VenSearchCondition = {
          venCd: this.searchType === '협력사명' ? null : this.searchInput,
          venNm: this.searchType === '협력사명' ? this.searchInput : null,
        }
        result = await this.$ustra.api.call<ApiResponse<Ven1stSearchList[]>>({
          url: '/api/cm/vendor/selectVendorList',
          method: HttpMethod.POST,
          data: { header, ...body },
          showLoading: false,
        })
      } else {
        const body: VenSearchCondition = {
          venCd: this.primaryVencd,
          ven2Cd: this.searchType === '협력사명' ? null : this.searchInput,
          ven2Nm: this.searchType === '협력사명' ? this.searchInput : null,
        }
        result = await this.$ustra.api.call<ApiResponse<Ven2ndSearchList[]>>({
          url: '/api/cm/vendor/selectVendor2List',
          method: HttpMethod.POST,
          data: { header, ...body },
        })
      }
      if (result.data.resultCode === '0000') {
        this.searchProgress = false
        this.venResultList = result.data.body
        this.pageInfo = {
          ...this.pageInfo,
          currentPage,
          totalRecords: result.data?.header?.totalRecords,
        }
      }
    } catch (e) {
      alert(e)
    }
  }

  // #endregion
  // #region watches
  // #endregion
}
